<!--勤怠詳細画面-->
<template>
  <div>
    <div class="all_area_k0002 ">
      <!--検索エイア-->
      <div class="search-module_k0002">
        <el-row>
          <el-col :span="4" class="el-col_k0002">
            <div class="grid-content bg-purple readonly_input">
              <span class="span_search_condition_k0002 ">{{$t('MODULE.K0002_LBL_CORPORATION_NAME')}}</span>
              <!--企業-->
              <el-input class=" css-input-width_k0002 " style="margin-top: 8px ;margin-left: 10px" size="small" v-model="company_name" :readonly="true"></el-input>
            </div>
          </el-col>
          <el-col :span="5" class="el-col_k0002">
            <div class="grid-content bg-purple readonly_input">
              <span class="span_search_condition_k0002" size="small">{{$t('MODULE.K0002_LBL_STORE_NAME')}}</span>
              <!--現場名-->
              <el-input class="css-input-width_k0002" style="margin-top: 8px ;margin-left: 10px" size="small" v-model="fieldName" :readonly="true"></el-input>
            </div>
          </el-col>
          <el-col :span="6" class="el-col_k0002">
            <div class="grid-content bg-purple readonly_input">
              <span class="span_search_condition_k0002">{{$t('COMMON.LBL_WORKDAY')}}</span>
              <!--作業日-->
              <el-input class="css-input-width_k0002 " style="margin-top: 8px; margin-left: 10px" size="small" v-model="job_date" :readonly="true"></el-input>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--入力エイア-->
      <div class="el-detail_k0002">
         <el-row >
          <div class="div_span_k0002">
            <!--出勤区分-->
            <span class="input_span_k0002">{{$t('MODULE.K0002_LBL_ATTENDANCE')}}</span>            
          </div>
        </el-row>
        <el-row >
          <div class="div_input_k0002 " style="text-align:center;" :class=" {readonly_input1:NeedReadonly('ATTENDANCE_DIV')}">
            <el-select class="input_input1_k0002" maxLength='5'  :disabled="NeedReadonly('ATTENDANCE_DIV')" placeholder="" v-model="attendanceDiv" @change="attendanceDivSelect(attendanceDiv)">
                <el-option v-for="item in attendanceList" :key="item.attendanceDiv" :label="item.attenAbbr" :value="item.attendanceDiv"></el-option>
            </el-select>
          </div>
        </el-row>
        <el-row v-show="this.workType == '1' || this.workType === '2'">
          <div class="div_span_k0002">
            <span class="input_span_k0002">{{$t('MODULE.K0002_LBL_POSITION')}}</span>
            <!--役職-->
            <span class="input_span_k0002">{{$t('MODULE.K0002_LBL_DAY_TEAM')}}</span>
            <!--当日チーム-->
          </div>
        </el-row>
        <el-row v-show="this.workType == '1' || this.workType === '2'">
          <div class="div_input_k0002 readonly_input1" style="text-align:center;">
            <el-input class="input_input1_k0002" v-model="storePositionDisplayName" :readonly="true"></el-input>
            <el-input class="input_input1_k0002" v-model="teamCd" :readonly="true"></el-input>
          </div>
        </el-row>
        <el-row>
          <div class="div_span_k0002 ">
            <span class="input_span_k0002">{{$t('MODULE.K0002_LBL_IN_STORE')}}</span>
            <!--入店時刻-->
            <span class="input_span_k0002">{{$t('MODULE.K0002_LBL_OUT_STORE')}}</span>
            <!--退店時刻-->
          </div>
        </el-row>
        <el-row>
          <div class="div_input_k0002 " :class=" {readonly_input1:NeedReadonly('STOREIN')||timeFlag=='0'}">
            <el-input class="input_input1_k0002" v-model="storeIn" maxlength="5" @blur="storeInBlur($event)" ref="storeInStatus" :readonly="NeedReadonly('STOREIN')||timeFlag=='0'" @input.native="timeInputCheck($event)" pattern="\d*" @focus="timeFocusInput($event)"></el-input>
            <el-input class="input_input1_k0002" v-model="storeOut" maxlength="5" @blur="storeOutBlur($event)" ref="storeOutStatus" :readonly="NeedReadonly('STOREOUT')||timeFlag=='0'" @input.native="timeInputCheck($event)" pattern="\d*" @focus="timeFocusInput($event)"></el-input>
          </div>
        </el-row>
        <el-row>
          <div class="div_span_k0002">
            <span class="input_span_k0002">{{$t('MODULE.K0002_LBL_ALL_REST_TIME')}}</span>
            <!--全休憩時間-->
            <span class="input_span_k0002">{{$t('MODULE.K0002_LBL_INLATE_BREAK')}}</span>
            <!--⇒内深夜休憩-->
          </div>
        </el-row>
        <el-row>
          <div class="div_input_k0002 " :class=" {readonly_input1:NeedReadonly('RESTTIME')||timeFlag=='0'}">
            <el-input class="input_input1_k0002" v-model="allRestTime" @blur="allRestTimeBlur($event)" ref="allRestTime" :readonly="NeedReadonly('RESTTIME')||timeFlag=='0'" @input.native="timeInputCheck($event)" pattern="\d*" @focus="timeFocusInput($event)"></el-input>
            <el-input class="input_input1_k0002" v-model="inLateBreak" @blur="inLateBreakBlur($event)" ref="inLateBreak" :readonly="NeedReadonly('INLATEBREAK')||timeFlag=='0'" @input.native="timeInputCheck($event)" pattern="\d*" @focus="timeFocusInput($event)"></el-input>
          </div>
        </el-row>
        <el-row>
          <div class="div_span_k0002">
            <!--実働時間-->
            <span class="input_span_k0002 ">{{$t('MODULE.K0002_LBL_WORK_TIME')}}</span>
            <!--⇒内深夜実働時間-->
            <span class="input_span_k0002">{{$t('MODULE.K0002_LBL_LATENIGHT_WORK_TIEM')}}</span>
          </div>
        </el-row>
        <el-row>
          <div class="div_input_k0002 readonly_input1" style="text-align:center;">
            <el-input class="input_input1_k0002" v-model="workTime" ref="workTime" :readonly="true"></el-input>
            <el-input class="input_input1_k0002" v-model="latenightWorkTime" ref="latenightWorkTime" :readonly="true"></el-input>
          </div>
        </el-row>
        <el-row v-show="workType=='3'">
          <div class="div_span_k0002">
            <!--出発コール時メモ-->
            <span class="input_span_k0002 ">{{$t('MODULE.K0002_LBL_DEPART')}}</span>
          </div>
        </el-row>
        <el-row v-show="workType=='3'">
          <div class="div_textarea_k0002" style="text-align:center;" :class="{readonly_textarea:NeedReadonly('DEPART')}">
            <el-input type="textarea" maxlength=500 :rows="2" class="input_textarea_k0002" v-model="departureCallMemo" ref="workTime" :readonly="NeedReadonly('DEPART')"></el-input>
          </div>
        </el-row>
        <el-row v-show="workType=='3'">
          <div class="div_span_k0002">
            <!--退店コールメモ-->
            <span class="input_span_k0002 ">{{$t('MODULE.K0002_LBL_QUIT')}}</span>
          </div>
        </el-row>
        <el-row v-show="workType=='3'">
          <div class="div_textarea_k0002" style="text-align:center;" :class="{readonly_textarea:NeedReadonly('QUIT')}">
            <el-input type="textarea" maxlength=500 :rows="2" class="input_textarea_k0002" v-model="returnCallMemo" ref="workTime" :readonly="NeedReadonly('QUIT')"></el-input>
          </div>
        </el-row>
        <el-row v-show="workType=='3'">
          <!--タイムシート写真-->
          <div class="div_span_k0002">
            <span class="input_span_k0002">{{$t('MODULE.K0002_LBL_PHOTO_INFO')}}</span>
          </div>
        </el-row>
        <el-row v-show="workType=='3'">
          <div class="photo_div">
            <div class="image_border" v-if="show_image_border"></div>
            <!--图片上传组件-->
            <el-upload ref="upload" :disabled="NeedReadonly('PHOTO_INFO')" :show-file-list="true" :file-list="timeSheetImageList" list-type="picture-card" :limit="2" accept="image/jpeg,image/gif,image/png,image/bmp,image/jpeg" action="#" :on-change=" (file, fileList)=> {handleChange(file, fileList,'photoImage','0')}" :auto-upload="false">
              <i class="el-icon-camera-solid avatar-uploader-icon" style="font-size:28px"></i>
              <div slot="file" slot-scope="{file}">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                <span class="el-upload-list__item-actions" @click="handlePictureCardPreview(file)">
                  <span v-if="false" class="el-upload-list__item-delete">
                  </span>
                </span>
              </div>
            </el-upload>
            <!--图片预览用viewer-->
            <el-image-viewer v-if="imageDialogVisible" :class={image_view_red:jobState_working,image_view_hidden:!jobState_working} :on-close="closeViewer" :url-list="[dialogImageUrl]" />
          </div>
        </el-row>
      </div>
      <!--保存-->
      <div>
        <el-row style="text-align:center;">
          <el-button class="css-btn css-button" type="primary" style="margin-top: 8px;font-size: 10pt;width:20%" @click="save_click" :disabled="NeedReadonly('SAVE_BTN')">{{$t('COMMON.BTN_SAVE')}}</el-button>
          <el-button class="css-btn css-button" type="primary" style="margin-top: 8px;font-size: 10pt;width:20%" @click="back_click">{{$t('COMMON.BTN_BACK')}}</el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import * as amsApi from "../api/k_0002"
import css from "@/statics/css"
import utilsApi from '../../common/utils'
let url = require('@/../config/sysConfig')
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  mixins: [css],
  components: {
    ElImageViewer
  },
  data() {
    return {
      inputFlag: false,
      obj: [],
      WORKING: '1',//作業中(常量)
      attendanceList:[],//作業区分リスト
      attendanceDiv:'',//作業区分cd 出勤区分
      jobState_working: false,//是否为作业中的判断FLAG：true=工作中
      approvalStatus: '1',//勤怠承認「1：承認」
      userInfo: [],
      job_date: '',
      company_name: '',
      fieldName: '',
      position: '',
      jobState: '',
      approvalFlag: '',//勤怠承認FLAG
      crewCd: '',
      cl: '',
      listLoading: false,
      list: [],
      total: 0, //総カウント
      checked: true,
      storePositionCd: '',//店舗役職Cd
      storePositionName: '',//店舗役職名
      storePositionDisplayCd: '',//店舗役職cd（表示用）
      storePositionDisplayName:'',//店舗役職名（表示用）
      timeFlag:'',//時刻フラグ
      teamCd: '',
      userCd: '',
      userName: '',
      storeIn: '',
      storeOut: '',
      breakTime: '',
      latenightBreakTime: '',
      transportExpenses: '',
      allRestTime: '',
      inLateBreak: '',
      workTime: '',
      latenightWorkTime: '',
      km: '',
      kmPrice: '',
      travelAllowance: '',
      commutingExpenses: '',
      transportExpensesTrip: '',
      accommodation: '',
      allowanceTrip: '',
      othersExpenses: '',
      oritenCost: '',
      ecoasTravelExpenses: '',
      ecoasFuelExpenses: '',
      transportTeate: '',
      updateDate: '',
      initFlg: 0,
      blurErrorFgl: false,
      changeFgl: false,
      departureCall: '',//出発コール
      returnCall: '',//退店コール
      departureCallMemo: '',//出発コールメモ
      returnCallMemo: '',//退店コールメモ
      personalJobState: '',//個人作業状態
      esStoreIn: '',//预测入店(前画面传入)
      esStoreOut: '',//预测退店(前画面传入)
      workType: '',//作業区分(前画面传入)
      goalFlg: '',//コールフラグ(前画面传入)
      dialogImageUrl: "",//timeSheet图片预览用的单张图片
      timeSheetImageList: [],//timeSheet初始化时的list
      updateLoad_timeSheetImageList: [],//timeSheet的保存前图片list。
      imageDialogVisible: false,//图片dialog是否显示flag
      show_image_border: true,//是否显示假图片框
      has_UpdateLoadedDel: false,//是否上传成功过
      delPhotoUrl: '',//删除用图片路径存储
      contractFormDiv:'',//契約種別
      strYesterday:''//昨日(字符串)
    }
  },
  methods: {
    //readonly判定
    NeedReadonly(type) {
      var readonlyReturn = false;
      switch (type) {
        case "STOREIN"://入店時刻
        case "STOREOUT"://退店時刻
        case "RESTTIME"://全休憩時間
        case "INLATEBREAK"://内深夜休憩
          if ((this.workType == '1' || this.workType === '2') && this.jobState !== this.WORKING) {
            readonlyReturn = true
          }
          if (this.workType === '3' && (this.goalFlg === '2' || this.goalFlg === '1')) {
            readonlyReturn = true
          }
          if (this.workType === '3' && this.goalFlg === '3' && (this.transmitFlag === '1' || this.jobState !== this.WORKING)) {
            readonlyReturn = true
          }
          if (this.workType === '3' && this.goalFlg === '3' && (this.personalJobState === '4') && this.jobState === this.WORKING) {
            readonlyReturn = true
          }
          break
        case "DEPART"://出発コールメモ
          if (this.workType === '3' && this.goalFlg === '2') {
            readonlyReturn = true
          }
          if (this.workType === '3' && this.goalFlg === '3' && (this.transmitFlag === '1' || this.jobState !== this.WORKING)) {
            readonlyReturn = true
          }
          if (this.workType === '3' && this.goalFlg === '3' &&  (this.personalJobState === '4'||this.personalJobState === '0') && this.jobState === this.WORKING) {
            readonlyReturn = true
          }
          break
        case "QUIT"://退店コールメモ
          if (this.workType === '3' && this.goalFlg === '1') {
            readonlyReturn = true
          }
          if (this.workType === '3' && this.goalFlg === '3') {
            readonlyReturn = true
          }
          break
        case "PHOTO_INFO"://タイムシート写真
          if (this.workType === '3' && this.goalFlg === '1') {
            readonlyReturn = true
          }
          if (this.workType === '3' && this.goalFlg === '3' && (this.transmitFlag === '1' || this.jobState !== this.WORKING)) {
            readonlyReturn = true
          }
          if (this.workType === '3' && this.goalFlg === '3' &&  (this.personalJobState === '4'||this.personalJobState === '0') && this.jobState === this.WORKING) {
            readonlyReturn = true
          }
          break
        case "SAVE_BTN"://保存ボタン
          if ((this.workType == '1' || this.workType === '2') && this.jobState !== this.WORKING) {
            readonlyReturn = true
          }
          if (this.workType === '3' && this.goalFlg === '3' && (this.transmitFlag === '1' || this.jobState !== this.WORKING)) {
            readonlyReturn = true
          }
          if (this.workType === '3' && this.goalFlg === '3' &&  this.personalJobState === '4' && this.jobState === this.WORKING) {
            readonlyReturn = true
          }
          break
        case "ATTENDANCE_DIV"://出勤区分
          if ((this.workType == '1' || this.workType === '2') && this.jobState == this.WORKING && this.contractFormDiv ==='1') {
            readonlyReturn = true
          }
          if ((this.workType == '1' || this.workType === '2') && this.jobState !== this.WORKING) {
            readonlyReturn = true
          }
          if (this.workType === '3' && this.goalFlg === '1' ) {
            readonlyReturn = true
          }
          if (this.workType === '3' && this.goalFlg === '2' ) {
            readonlyReturn = true
          }          
          if (this.workType === '3' && this.goalFlg === '3' && (this.transmitFlag === '1' || this.jobState !== this.WORKING)) {
            readonlyReturn = true
          }
          if (this.workType === '3' && this.goalFlg === '3' &&  this.personalJobState === '4' && this.jobState === this.WORKING) {
            readonlyReturn = true
          }
           if (this.workType === '3' && this.goalFlg === '3' &&  this.personalJobState === '0' && this.jobState === this.WORKING && this.contractFormDiv ==='1') {
            readonlyReturn = true
          }
          if (this.workType === '3' && this.goalFlg === '3' && this.personalJobState !== '4'&&this.personalJobState !== '0' && this.jobState === this.WORKING && this.contractFormDiv ==='1') {
            readonlyReturn = true
          }
          break  
      }
      return readonlyReturn;
    },
    //单张图片删除
    fileRemove(file) {
      //组件表示图片清空
      this.$refs.upload.clearFiles()
      //上传用list清空
      this.updateLoad_timeSheetImageList[0] = {}
      this.show_image_border = true
      this.has_UpdateLoadedDel = true
    },
    //单张图片点击
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imageDialogVisible = true;
    },
    // 画像上传成功后处理
    handleChange(file, fileList, itemName, type) {
      var file_type = file.raw.type
      // 上传图片的格式判定，失败的场合不上传
      if (!(file_type === 'image/jpeg' || file_type === 'image/gif' || file_type === 'image/png' || file_type === 'image/bmp' || file_type === 'image/jpeg')) {
        this.$message.error({ message: this.$t('COMMON.MSG_PICTURE_FORMAT'), showClose: true });
        // 回复原来的样子
        if (fileList.length == 1) {
          fileList = fileList.splice(0, 1);
        }
        if (fileList.length > 1) {
          fileList = fileList.splice(1, 1);
        }
      } else {
        //变更flg设定
        this.changeFgl = true
        // 当有文件的时候先删除旧文件再上传新的
        if (fileList.length > 1) {
          fileList = fileList.splice(0, 1);
        }
        //假图片框若有的话，隐藏
        if (this.show_image_border == true) {
          this.show_image_border = false
        }
        //执行过图片操作处理
        this.has_UpdateLoadedDel = true

        // 写真パス：「image/personalPhoto/クルーコード/社員ID_店舗役職CD（表示用）_種別_写真ID.jpg」
        //写真パス：「image/personalPhoto/クルーコード/社員ID_店舗役職CD（表示用）_種別_写真ID_yyyyMMddHHmmssSSS.拡張子」
        var that = this
        // var photoItem = {}
        this.getBase64(file.raw).then(async res => {
          // 进行图片压缩获取压缩后的blob文件
          var photo = await that.compressImg(that.base64ToBlob(res))
          let files = new window.File([photo], file.name, { type: file.type })
          var timenumber = utilsApi.timeNumberGet()
          let photoPath = 'image/personalPhoto/' + that.crewCd + '/' + that.userCd + '_' + that.storePositionCd + '_' + type + '_' + '0_' + timenumber + '.jpg'
          this.updateLoad_timeSheetImageList[0] = {}
          this.updateLoad_timeSheetImageList[0].files = files
          this.updateLoad_timeSheetImageList[0].photoId = type
          this.updateLoad_timeSheetImageList[0].photoPath = photoPath
          this.updateLoad_timeSheetImageList[0].type = type
        })

      }


    },

    // 图片转base64
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },

    // base转blob
    base64ToBlob(file) {
      let byteString;
      if (file.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(file.split(',')[1])
      } else {
        byteString = unescape(file.split(',')[1])
      }
      let mimeString = file
        .split(',')[0]
        .split(':')[1]
        .split(';')[0];
      let ia = new Uint8Array(byteString.length)
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], { type: mimeString })
    },

    // 压缩图片
    compressImg(file) {
      var that = this
      var files;
      var fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2);
      var read = new FileReader();
      read.readAsDataURL(file);
      return new Promise(function (resolve, reject) {
        read.onload = function (e) {
          var img = new Image();
          img.src = e.target.result;
          img.onload = function () {
            //默认按比例压缩
            var w = this.width,
              h = this.height;
            //生成canvas
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var base64;
            // 创建属性节点
            canvas.setAttribute("width", w);
            canvas.setAttribute("height", h);
            ctx.drawImage(this, 0, 0, w, h);

            if (fileSize <= 1) {
              //如果图片小于一兆 那么不执行压缩操作
              base64 = canvas.toDataURL(file['type'], 0.94);
            } else if (fileSize > 1 && fileSize <= 5) {
              //如果图片大于1M并且小于5M 
              base64 = canvas.toDataURL(file['type'], 0.35);
            } else if (fileSize > 5 && fileSize <= 8) {
              base64 = canvas.toDataURL(file['type'], 0.2);
            } else if (fileSize > 8 && fileSize <= 12) {
              base64 = canvas.toDataURL(file['type'], 0.1);
            } else {
              base64 = canvas.toDataURL(file['type'], 0.05);
            }
            // 回调函数返回file的值（将base64编码转成file）
            files = that.base64ToBlob(base64); //如果后台接收类型为base64的话这一步可以省略
            resolve(files)
          };
        };
      })
    },
    // 关闭查看器
    closeViewer() {
      this.$confirm(this.$t('COMMON.MSG_IMAGE_DEL'), { // 変更がありました。一覧に戻りますか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: true
      }).then(() => {
        //组件表示图片清空
        this.$refs.upload.clearFiles()
        //上传用list清空
        this.updateLoad_timeSheetImageList[0] = {}
        this.show_image_border = true
        this.has_UpdateLoadedDel = true
        this.imageDialogVisible = false
        this.changeFgl = true
      }).catch(() => {

      })

    },
    /* 图片压缩方法-canvas压缩 */
    compressUpload(image, file) {
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      let initSize = image.src.length
      let { width } = image, { height } = image
      canvas.width = width
      canvas.height = height
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(image, 0, 0, width, height)
      // 进行最小压缩0.5
      let isLt2M = file.size / 1024 / 1024
      let compressData;
      if (5 < isLt2M < 10) {
        compressData = canvas.toDataURL(file.type || 'image/jpeg', 0.1)
      } else {
        compressData = canvas.toDataURL(file.type || 'image/jpeg', 0.5)
      }
      //压缩后调用方法进行base64转Blob，方法写在下边
      let blobImg = this.dataURItoBlob(compressData)
      return blobImg
    },

    //金额每三位加','
    NumericalFormatter(val) {
      if (val != null && val !== '') {
        var reg = /[^\d]/
        if (reg.test(val)) {

          val = val.replace(/[^0-9]/ig, ',')
        }
        if (val !== '0' && val !== '0.0') {
          var regex = /^[0]+/
          val = val.toString().replace(regex, '')
        }

        return val.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      } else {
        return '0'
      }
    },
    // 小数金额每三位加','
    NumericalFormatterDigit(val) {
      val = Number(val).toFixed(1)
      val = val.toString()
      var ret = ''
      if (val != null && val !== '') {
        if (val.indexOf('.') !== -1) {
          var strDigit = val.substring(val.indexOf('.'))
          var strInt = val.substring(0, val.indexOf('.'))
          ret = this.NumericalFormatter(strInt) + '' + strDigit
        } else {
          ret = this.NumericalFormatter(strInt)
        }
        return ret
      } else {
        return '0.0'
      }
    },

    // 带,金额转number
    strToNum(val) {
      if (val != null && val !== '') {
        return Number(val.replace(/,/g, ''))
      } else {
        return 0
      }
    },
    // 时间入力check
    timeInputCheck(item) {
      this.changeFgl = true
      var reg = /^\d*(\:?\d{0,2})/g
      var matchResult = item.target.value.match(reg)
      if (matchResult === null) {
        item.target.value = null
      } else {
        item.target.value = matchResult[0]
      }
    },
    inputcompositionstart(item) {
      //  this.allowanceTrip = '5'
      this.inputFlag = false
    },
    inputcompositionend(item) {
      // this.allowanceTrip = '7'
      this.inputFlag = true
    },
    // 数字入力check
    numberInputCheck(item) {
      this.changeFgl = true
      var aa = JSON.parse(JSON.stringify(item.target.value))
      item.target.value = aa.replace(/([^\d])/g, '').slice(0, 8)
    },
    // 小数入力check
    floatInputCheck(item) {
      this.changeFgl = true
      var reg = /^\d*(\.?\d{0,1})/g
      if (item.target.value === null) {
        item.target.value = null
      } else {
        var matchResult = item.target.value.match(reg)
        item.target.value = matchResult[0].slice(0, 8)
      }
    },
    // KM BLURチェック
    kmBlurCheck(e) {
      this.changeFgl = true
      var reg = /(^[0-9]{0,6}$)|(^[0-9]{1,6}[\.]{1}[0-9]{1}$)/g
      if (reg.test(e.currentTarget.value)) {
        var kmValue = JSON.parse(JSON.stringify(e.currentTarget.value));
        var changValue = 0
        if (kmValue === null || kmValue === '' || kmValue === '0' || this.transportTeate === null || this.transportTeate === '' || this.transportTeate === 0) {
          changValue = 0
        } else {
          changValue = (Math.round(Number(kmValue) * Number(this.transportTeate))).toFixed(0)
        }
        this.kmPrice = this.NumericalFormatter(changValue.toString())
        this.km = this.NumericalFormatterDigit(e.currentTarget.value)
        e.currentTarget.value = this.km
        this.blurErrorFgl = false;
      } else {
        this.$nextTick((x) => {
          this.$refs.km.focus();
          this.$message.error({ message: this.$t('COMMON.MSG_GOODS_INPUT_VALIDITY'), showClose: true });
        })
        this.blurErrorFgl = true;
      }
    },
    // 時刻チェック46
    timeBlurCheck(item) {
      var myTime = item.currentTarget.value
      var reg = /^(([0-3][0-9]|4[0-5])[0-5][0-9]|4600)$/
      var reg1 = /^(([0-3][0-9]|4[0-5]):[0-5][0-9]|46:00)$/
      var reg2 = /^(([0-5]?[0-9])|([0-9][0-5][0-9]))$/
      if (myTime === '') {
        this.blurErrorFgl = false;
        return '';
      }
      if (reg.test(myTime)) {
        var str11 = myTime.substring(0, 2);
        var strSep = ":";
        var str00 = myTime.substring(2, myTime.length);
        var strNew = str11 + strSep + str00;
        item.currentTarget.value = strNew
        this.blurErrorFgl = false;
        return item.currentTarget.value
      } else if (reg1.test(myTime)) {
        this.blurErrorFgl = false;
        return item.currentTarget.value
      } else if (reg2.test(myTime)) {
        var value_4 = (Array(4).join(0) + myTime).slice(-4);
        var str11 = value_4.substring(0, 2);
        var strSep = ":";
        var str00 = value_4.substring(2, value_4.length);
        var strNew = str11 + strSep + str00;
        item.currentTarget.value = strNew;
        this.blurErrorFgl = false;
        return item.currentTarget.value
      } else {
        this.blurErrorFgl = true;
        return '';
      }
    },
    // 時刻チェック24
    timeBlurCheck_24(item) {
      var myTime = item.currentTarget.value
      var reg = /^(([0-1][0-9]|2[0-3])[0-5][0-9])$/
      var reg1 = /^(([0-1][0-9]|2[0-3]):[0-5][0-9])$/
      var reg2 = /^(([0-2]?[0-9])|([0-9][0-5][0-9]))$/
      if (myTime === '') {
        this.blurErrorFgl = false;
        return ''
      }
      if (reg.test(myTime)) {
        var str11 = myTime.substring(0, 2);
        var strSep = ":";
        var str00 = myTime.substring(2, myTime.length);
        var strNew = str11 + strSep + str00;
        item.currentTarget.value = strNew
        this.blurErrorFgl = false;
        return item.currentTarget.value
      } else if (reg1.test(myTime)) {
        this.blurErrorFgl = false;
        return item.currentTarget.value
      } else if (reg2.test(myTime)) {
        var value_4 = (Array(4).join(0) + myTime).slice(-4);
        var str11 = value_4.substring(0, 2);
        var strSep = ":";
        var str00 = value_4.substring(2, value_4.length);
        var strNew = str11 + strSep + str00;
        item.currentTarget.value = strNew;
        this.blurErrorFgl = false;
        return item.currentTarget.value
      } else {
        this.blurErrorFgl = true;
        return '';
      }
    },
    storeInBlur(item) {
      var retValue = this.timeBlurCheck_24(item)
      if (this.blurErrorFgl == true) {
        this.$nextTick((x) => {
          if (this.$refs.storeInStatus != null) {
            this.$refs.storeInStatus.focus()
            this.$message.error({ message: this.$t('COMMON.MSG_TIME_VALIDITY_24'), showClose: true })
          }
        })
      } else {
        this.storeIn = retValue
      }
    },
    storeOutBlur(item) {
      var retValue = this.timeBlurCheck(item)
      if (this.blurErrorFgl == true) {
        this.$nextTick((x) => {
          if (this.$refs.storeOutStatus != null) {
            this.$refs.storeOutStatus.focus()
            this.$message.error({ message: this.$t('COMMON.MSG_TIME_VALIDITY'), showClose: true })
          }
        })
      } else {
        this.storeOut = retValue
      }
    },
    //深夜时间带计算
    //深夜时段：时间带1：00:00~05:00  时间带2：22:00~29:00
    getInLateBlock(value_in, value_out) {
      var ret_totalTime = 0;
      var cal_value_out = 0
      var cal_value_in = 0
      var S_IN1 = 0
      var S_OUT1 = 5 * 60
      var S_IN2 = 22 * 60
      var S_OUT2 = 29 * 60
      //时间带1计算
      if ((S_IN1 <= value_in && value_in <= S_OUT1) || (S_IN1 <= value_out && value_out <= S_OUT1)) {
        cal_value_in = value_in < S_IN1 ? S_IN1 : value_in
        cal_value_out = value_out > S_OUT1 ? S_OUT1 : value_out
        ret_totalTime = cal_value_out - cal_value_in + ret_totalTime
      } else if ((S_IN1 >= value_in && value_out >= S_OUT1)) {
        ret_totalTime = S_OUT1 - S_IN1 + ret_totalTime
      }
      cal_value_out = 0
      cal_value_in = 0
      //时间带2计算
      if ((S_IN2 <= value_in && value_in <= S_OUT2) || (S_IN2 <= value_out && value_out <= S_OUT2)) {
        cal_value_in = value_in < S_IN2 ? S_IN2 : value_in
        cal_value_out = value_out > S_OUT2 ? S_OUT2 : value_out
        ret_totalTime = cal_value_out - cal_value_in + ret_totalTime
      } else if ((S_IN2 >= value_in && value_out >= S_OUT2)) {
        ret_totalTime = S_OUT2 - S_IN2 + ret_totalTime
      }
      return ret_totalTime
    },
    //全休憩時間失去焦点事件
    allRestTimeBlur(item) {
      var retValue = this.timeBlurCheck(item)
      if (this.blurErrorFgl == true) {
        this.$nextTick((x) => {
          if (this.$refs.allRestTime != null) {
            this.$refs.allRestTime.focus()
            this.$message.error({ message: this.$t('COMMON.MSG_TIME_VALIDITY'), showClose: true })
          }
        })
      } else {
        this.allRestTime = retValue
      }
    },
    //内深夜休憩失去焦点事件
    inLateBreakBlur(item) {
      var retValue = this.timeBlurCheck(item)
      if (this.blurErrorFgl == true) {
        this.$nextTick((x) => {
          if (this.$refs.inLateBreak != null) {
            this.$refs.inLateBreak.focus()
            this.$message.error({ message: this.$t('COMMON.MSG_TIME_VALIDITY'), showClose: true })
          }
        })
      } else {
        this.inLateBreak = retValue
      }
    },
    //(时间用)获取焦点事件
    timeFocusInput(e) {
      var obj = e.srcElement;
      obj.focus()
      obj.selectionStart = e.currentTarget.value.length
      obj.selectionEnd = e.currentTarget.value.length
    },

    // 検索
    query() {

      var Params = {
        'crewCd': this.crewCd,
        'jobState': this.jobState,
        'storePositionCd': this.storePositionCd,
        'userId': this.userInfo.userCd,
        'status': '2',
        'trminal': 'staff'
      }
      // 検索処理
      amsApi.k_0002(Params).then(res => {
        this.job_date = res.items[0].jobDate
        this.company_name = res.items[0].companyName
        //this.fieldName = res.items[0].fieldName
        this.storePositionCd = res.items[0].storePositionCd;
        //this.storePositionName = res.items[0].storePositionName;
        this.storePositionDisplayName = res.items[0].storePositionDisplayName;
        this.teamCd = res.items[0].teamCd;
        this.userCd = res.items[0].userCd;
        this.userName = res.items[0].userName;
        this.storeIn = res.items[0].storeIn;
        this.storeOut = res.items[0].storeOut;
        this.breakTime = res.items[0].breakTime;
        this.allRestTime = res.items[0].allRestTime;
        this.inLateBreak = res.items[0].inLateBreak;
        this.workTime = res.items[0].workTime;
        this.latenightWorkTime = res.items[0].latenightWorkTime;
        this.latenightBreakTime = res.items[0].latenightBreakTime;
        this.transportExpenses = this.NumericalFormatter(res.items[0].transportExpenses)
        this.km = this.NumericalFormatterDigit(res.items[0].km)
        this.kmPrice = this.NumericalFormatter(res.items[0].kmPrice)
        this.travelAllowance = this.NumericalFormatter(res.items[0].travelAllowance)
        this.commutingExpenses = this.NumericalFormatter(res.items[0].commutingExpenses)
        this.transportExpensesTrip = this.NumericalFormatter(res.items[0].transportExpensesTrip)
        this.accommodation = this.NumericalFormatter(res.items[0].accommodation)
        this.allowanceTrip = this.NumericalFormatter(res.items[0].allowanceTrip)
        this.othersExpenses = this.NumericalFormatter(res.items[0].othersExpenses)
        this.oritenCost = this.NumericalFormatter(res.items[0].oritenCost)
        this.ecoasTravelExpenses = this.NumericalFormatter(res.items[0].ecoasTravelExpenses)
        this.ecoasFuelExpenses = this.NumericalFormatter(res.items[0].ecoasFuelExpenses)
        this.transportTeate = res.items[0].transportTeate
        this.updateDate = res.items[0].updateDate
        this.departureCallMemo = res.items[0].departureCallMemo
        this.returnCallMemo = res.items[0].returnCallMemo
        this.departureCall = res.items[0].departureCall
        this.returnCall = res.items[0].returnCall
        this.personalJobState = res.items[0].personalJobState
        this.timeFlag =res.items[0].timeFlag
        this.attendanceDiv =res.items[0].attendanceDiv
        this.contractFormDiv = res.items[0].contractFormDiv
        this.storePositionDisplayCd=res.items[0].storePositionDisplayCd
        console.log('this.timeFlag:'+this.timeFlag)
        //作業区分リスト取得
        this.searchAttendanceList()
        //作業区分は「3」派遣・その他請負の場合、タイムシートを取得し表示する。
        if (this.workType === '3') {
          //图片取得
          var getPhotoInfoParams = {}
          getPhotoInfoParams.crewCd = this.crewCd
          getPhotoInfoParams.storePositionCd = this.storePositionCd
          getPhotoInfoParams.userId = this.userCd
          getPhotoInfoParams.type = '0'
          //照片路径等信息取得API
          amsApi.k_0002_getPhotoInfo(getPhotoInfoParams).then(res_photoInfo => {
            if (res_photoInfo.code === 204 && res_photoInfo.items.personalPhotoData.length > 0) {
              var getPhotoImageParams = {}
              getPhotoImageParams.filePath = res_photoInfo.items.personalPhotoData[0].photoPath
              getPhotoImageParams.resizeCd = '0'
              //照片取得
              amsApi.k_0002_getImage(getPhotoImageParams).then(res_photo => {
                let blob = new Blob([res_photo], { type: 'image/jpeg' })
                var url = window.URL.createObjectURL(blob)
                //  var url= 'data:image/jpeg;base64,' + btoa(new Uint8Array(res_photo).reduce((data, byte) => data + String.fromCharCode(byte), ''));
                var urlsLength = this.timeSheetImageList.length
                var oneImage = {}
                oneImage.name = 'test.jpeg'
                oneImage.url = url
                oneImage.filePath = getPhotoImageParams.filePath

                this.delPhotoUrl = getPhotoImageParams.filePath
                this.timeSheetImageList = []
                this.timeSheetImageList.splice(urlsLength, 0, oneImage)
                this.show_image_border = false

                //  this.photoListSum = this.photoListSum - 1
                //没有文件和图片时关闭loading
                // if (this.photoListSum === 0) {
                //关闭loading
                //   this.close_loading()
                // }
              }).catch((err) => {
                //关闭loading
                // this.close_loading()
                // 按钮非活性
                // this.save_btn_disabled = true;
              })
            } else {
              //return
            }
          }).catch((err) => {
          })
        }
      })
    },
    // 整形入力
    // handleInput(e) {
    //   if(e.keyCode == 48){return;}
    //   let a = e.key.replace(/[^\d]/g, "");
    //   if (!a) {
    //     e.preventDefault();
    //   }
    // },
    // 退出登录处理
    log_out() {
      this.$message.closeAll()
      var vm = this
      vm.$router.push({ path: "/login" })
    },
    // 戻る処理
    back_click() {
      if (this.changeFgl === true) {
        this.$confirm(this.$t('COMMON.MSG_MESSAGE_CHANGE_BACK'), { // 変更がありました。一覧に戻りますか？
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
          center: true
        }).then(() => {
          var vm = this
          vm.$router.push({ path: url.routerUrl_K0001 })
        }).catch(() => {
        })
      } else {
        var vm = this
        vm.$router.push({ path: url.routerUrl_K0001 })
      }
    },
    // 数据保存的返回值（res_code）処理
    res_code_back(res) {
      if (res.code === 202) {
        this.changeFgl = false
        this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true }) // 更新成功
        //更新成功的场合，清空更新用图片list
        this.updateLoad_timeSheetImageList[0] = {}
        //更新成功的场合，图片操作初始化false
        this.has_UpdateLoadedDel = false
        this.query()
      } else if (res.code === 308) {
        setTimeout(() => {
          this.$confirm(this.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            center: true
          }).then(() => {
            var vm = this
            vm.$router.push({ path: url.routerUrl_K0001 })
          }).catch(() => {
          })
        }, 500)
      } else if (res.code === 408) {
        setTimeout(() => {
          this.$confirm(this.$t('COMMON.MSG_ERROR_STATE_OVER'), { // 作業状態はもう作業完了でした。他の人が先に更新した可能性があります。最新情報を取得しますか？
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            center: true
          }).then(() => {
            var vm = this
            vm.$router.push({ path: url.routerUrl_K0001 })
          }).catch(() => {
          })
        }, 500)
        //add by hexy 20200921 start 
      } else if (res.code === 428) {
        setTimeout(() => {
          this.$confirm(this.$t('COMMON.MSG_TRANSMIT'), { // 勤怠承認済、戻り値メッセージを表示する
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
            center: true
          }).then(() => {
            // はい
            var vm = this
            vm.$router.push({ path: url.routerUrl_K0001 })
          }).catch(() => {
            // いいえ
          })
        }, 500) 
        //add by hexy 20200921 end 
      // } else if (res.code === 427) {
      //   setTimeout(() => {
      //     this.$confirm(this.$t('COMMON.MSG_APPROVAL'), { // 勤怠承認済、戻り値メッセージを表示する
      //       confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
      //       cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
      //       center: true
      //     }).then(() => {
      //       // はい
      //       var vm = this
      //       vm.$router.push({ path: url.routerUrl_K0001 })
      //     }).catch(() => {
      //       // いいえ
      //     })
      //   }, 500)
      } else if (res.code === 615) {
        var reg1 = '{0}'
        var msg = this.$t('COMMON.MSG_KINTAI_DIV_CHK1').replace(reg1, this.attenAbbr)
        this.$message.error({ message: msg, showClose: true }) // 出勤区分が{0}の場合、2件以上の勤怠は入力できません
      } else if (res.code === 616) {//複数な勤怠を入力する場合、出勤区分は一致する必要があります。
        this.$message.error({ message: this.$t('COMMON.MSG_KINTAI_DIV_CHK2'), showClose: true }) 
      } else if (res.code === 617) {
        var reg1 = '{0}'
        var reg2 = '{1}'
        var msg = this.$t('COMMON.MSG_KINTAITIME_VALIDITY').replace(reg1, res.items.InOut).replace(reg2, res.items.dbInOut)
        this.$message.error({ message: msg, showClose: true }) // 更新失敗  
      } else {
        this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true }) // 更新失敗
      }
    },

    // 保存按钮事件
    save_click() {
      var today = new Date()
      var strTodayHHMM = this.dateToStringHHMM(today, 0)
      var strTrueTodayHHMM=''
      // 棚卸日が昨日の場合、時+24処理
      if(this.strYesterday === this.job_date){
        strTrueTodayHHMM = this.dateToStringHHMM(today, 24) 
      }
      
      //---------------------------------コールフラグは1:出発コールの場合-----------------------------------------
      if (this.goalFlg === '1') {
        this.$confirm(this.$t('COMMON.MSG_MESSAGE_DEPARTURE_CALL_MEMO'), { // 出発コール時メモを保存します。よろしいでしょうか。
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true
        }).then(() => {
          var Params = {
            'crewCd': this.crewCd,
            'jobDate': this.job_date,
            'storePositionCd': this.storePositionCd,
            'departureCall': strTodayHHMM,
            'div': '3',
            'personalJobState': '1',
            'departureCallMemo': this.departureCallMemo
          }
          amsApi.k_0002_Attendances_update(Params).then(res => {
            if (res.code == 202) {
              this.changeFgl = false
              //成功返回
              this.back_click()
            } else if (res.code == 311) {
              //失败提示
              that.$message.error({ message: that.$t('COMMON.CURD_ERROR'), showClose: true }) // 更新失敗
            }
          })
        }).catch(() => {
          //いいえ　無処理
        })
      } else if (this.goalFlg === '2') {

        //---------------------------コールフラグは2:退店コールの場合-----------------------------------
        //退店コール(現時点)と退店の関連チェック
        if (this.storeOut !== null && this.storeOut !== '') {
          if(this.strYesterday === this.job_date){
            strTodayHHMM = strTrueTodayHHMM
          }
          var min_strHHMM = Number(strTodayHHMM.substring(0, 2)) * 60 + Number(strTodayHHMM.substring(3, 5));
          var min_storeOut = Number(this.storeOut.substring(0, 2)) * 60 + Number(this.storeOut.substring(3, 5));
          //退店＞退店コール(現時点)の場合 エラー
          if (min_storeOut > min_strHHMM) {
            this.$message.error({ message: this.$t('COMMON.MSG_RETURN_CALL_OUT_VALIDITY'), showClose: true });//退店＜退店コールで入力してください。
            return;
          }
          // 退店時刻が46時を超えるかチェック
          if (min_strHHMM > 46 * 60) { // 最大46：00 以上の場合
            this.$message.error({ message: this.$t('COMMON.MSG_ERROR_OUTSTORE_24'), showClose: true })// 退店時刻が最大46：00まで入力してください。
            return;
          }
        }
        this.photoFormData = new FormData()
        var that = this
        //图片存在チェック
        // let image_control = document.querySelector(
        //   ".el-upload-list__item-thumbnail"
        // );
        // if (image_control === null) {
        //   // this.$message.error({ message: this.$t('COMMON.MSG_MESSAGETIMESHEET_PHOTO_CHECK'), showClose: true });//タイムシート写真を添付してください。
        // } else {
        this.$confirm(this.$t('COMMON.MSG_MESSAGE_RETURN_CALL_MEMO'), { // 退店コール時メモを保存します。よろしいでしょうか。
          confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
          cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
          center: true
        }).then(() => {
          this.set_loading()
          //有图片操作且图片上传list有的场合，保存图片
          if (this.updateLoad_timeSheetImageList.length !== 0 && Object.keys(this.updateLoad_timeSheetImageList[0]).length !== 0) {
            this.photoFormData.append('files', this.updateLoad_timeSheetImageList[0].files, this.updateLoad_timeSheetImageList[0].photoPath)
            amsApi.k_0002_saveImage(this.photoFormData).then(res => {
              //保存图片成功，保存数据
              if (res.code == 205) {
                var Params = {
                  'crewCd': this.crewCd,
                  'jobDate': this.job_date,
                  'storePositionCd': this.storePositionCd,
                  'returnCall': strTodayHHMM,
                  'div': '4',
                  'personalJobState': '4',
                  'returnCallMemo': this.returnCallMemo,
                  'delPhotoUrl': this.delPhotoUrl,
                  'updateDate': this.updateDate
                }
                Params.photoItem = []
                Params.photoItem.push({
                  photoId: this.updateLoad_timeSheetImageList[0].photoId,
                  photoPath: this.updateLoad_timeSheetImageList[0].photoPath,
                  type: this.updateLoad_timeSheetImageList[0].type,
                })
                amsApi.k_0002_Attendances_update(Params).then(res => {
                  this.close_loading()
                  if (res.code == 202) {
                    this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true }) // 更新成功
                    this.$alert(this.$t('COMMON.MSG_MESSAGE_RETURN_SAVE_OVER'), { // お疲れ様でした。気を付けてお帰りください。経費入力が有れば忘れずに、入力お願いします。
                      confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
                      center: true
                    }).then(() => {
                      this.changeFgl = false
                      //成功返回
                      this.back_click()
                    })
                  } else if (res.code == 311) {
                    //失败提示
                    that.$message.error({ message: that.$t('COMMON.CURD_ERROR'), showClose: true }) // 更新失敗
                  } else if (res.code === 308) {
                    setTimeout(() => {
                      this.$confirm(this.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
                        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
                        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
                        center: true
                      }).then(() => {
                        var vm = this
                        vm.$router.push({ path: url.routerUrl_K0001 })
                      }).catch(() => {
                      })
                    }, 500)
                  }
                })
              } else if (res.code == 311) {
                this.close_loading()
                //图片上传失败
                that.$message.error({ message: that.$t('COMMON.CURD_ERROR'), showClose: true }) // 更新失敗
              }
            })
          } else {//图片list没有的场合 if (this.updateLoad_timeSheetImageList.length !== 0 && Object.keys(this.updateLoad_timeSheetImageList[0]).length !== 0) 
            var Params = {
              'crewCd': this.crewCd,
              'jobDate': this.job_date,
              'storePositionCd': this.storePositionCd,
              'returnCall': strTodayHHMM,
              'div': '4',
              'personalJobState': '4',
              'returnCallMemo': this.returnCallMemo,
              'updateDate': this.updateDate
            }
            amsApi.k_0002_Attendances_update(Params).then(res => {
              if (res.code == 202) {
                this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true }) // 更新成功
                this.$alert(this.$t('COMMON.MSG_MESSAGE_RETURN_SAVE_OVER'), { // お疲れ様でした。気を付けてお帰りください。経費入力が有れば忘れずに、入力お願いします。
                  confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
                  center: true
                }).then(() => {
                  //成功返回
                  this.back_click()
                })
              } else if (res.code == 311) {
                //失败提示
                that.$message.error({ message: that.$t('COMMON.CURD_ERROR'), showClose: true }) // 更新失敗
              } else if (res.code === 308) {
                setTimeout(() => {
                  this.$confirm(this.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
                    confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
                    cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
                    center: true
                  }).then(() => {
                    var vm = this
                    vm.$router.push({ path: url.routerUrl_K0001 })
                  }).catch(() => {
                  })
                }, 500)
              }
            })
          }
        }).catch(() => {
          //いいえ　無処理
        })
        // }
      } else if (this.goalFlg === '3') {
        //-----------------------------コールフラグは3:明細の場合------------------------
        if (this.blurErrorFgl) {
          return
        }
        //時刻フラグは0の場合、入店、退店、全休憩時間、内深夜休憩  入力できません
        if(this.timeFlag=='0'){
          if(this.storeIn !=null && this.storeIn !=''){
              this.$message.error({ message: this.$t('COMMON.MSG_KINTAI_INPUT').replace('{0}', this.attenAbbr).replace('{1}', this.$t('MODULE.C0003_DIALOG_SPAN_IN_STORE')), showClose: true });
              return;
          }
          if(this.storeOut !=null && this.storeOut !=''){
              this.$message.error({ message: this.$t('COMMON.MSG_KINTAI_INPUT').replace('{0}', this.attenAbbr).replace('{1}', this.$t('MODULE.C0003_DIALOG_SPAN_OUT_STORE')), showClose: true });
              return;
          }
          if(this.allRestTime !=null && this.allRestTime !=''){
              this.$message.error({ message: this.$t('COMMON.MSG_KINTAI_INPUT').replace('{0}', this.attenAbbr).replace('{1}', this.$t('MODULE.C0003_DIALOG_SPAN_NORMAL_REST')), showClose: true });
              return;
          }
          if(this.inLateBreak !=null && this.inLateBreak !=''){
              this.$message.error({ message: this.$t('COMMON.MSG_KINTAI_INPUT').replace('{0}', this.attenAbbr).replace('{1}', this.$t('MODULE.C0003_DIALOG_SPAN_DARK_REST')), showClose: true });
              return;
          }
        }else{
          // 必須入力（入店）
          if (this.storeIn == null || this.storeIn === '') {
            this.$message.error({ message: this.$t('COMMON.STORE_IN_MSG_EQUIRED_VALIDITY'), showClose: true })// 入店は入力必須項目です
            return
          }
          // 入店の有効性チェック(入力時チェック)
          // 時間の有効性チェック(入力時チェック)
          // 入店時刻(分)
          var min_storeIn = Number(this.storeIn.substring(0, 2)) * 60 + Number(this.storeIn.substring(3, 5));
          // 退店時刻(分)
          var min_storeOut = (this.storeOut == null || this.storeOut === '') ? 0 : Number(this.storeOut.substring(0, 2)) * 60 + Number(this.storeOut.substring(3, 5));
          // 予測入店時刻(分)
          var min_esstoreIn = (this.esStoreIn == null || this.esStoreIn === '') ? 0 : Number(this.esStoreIn.substring(0, 2)) * 60 + Number(this.esStoreIn.substring(3, 5));
          // 予測退店時刻(分)
          var min_esstoreOut = (this.esStoreOut == null || this.esStoreOut === '') ? 0 : Number(this.esStoreOut.substring(0, 2)) * 60 + Number(this.esStoreOut.substring(3, 5));
          //出発コール(分)
          var min_departureCall = (this.departureCall == null || this.departureCall === '') ? 0 : Number(this.departureCall.substring(0, 2)) * 60 + Number(this.departureCall.substring(3, 5));
          //退店コール(分)
          var min_returnCall = (this.returnCall == null || this.returnCall === '') ? 0 : Number(this.returnCall.substring(0, 2)) * 60 + Number(this.returnCall.substring(3, 5));
          //全休憩時間(分)
          if (this.allRestTime === null || this.allRestTime === '') {
            var min_allRestTime = 0;
          } else {
            var min_allRestTime = Number(this.allRestTime.substring(0, 2)) * 60 + Number(this.allRestTime.substring(3, 5));
          }
          //内深夜休憩(分)
          if (this.inLateBreak === null || this.inLateBreak === '') {
            var min_inLateBreak = 0;
          } else {
            var min_inLateBreak = Number(this.inLateBreak.substring(0, 2)) * 60 + Number(this.inLateBreak.substring(3, 5));
          }
          // 入店＞＝退店 チェック
          if (this.storeOut !== null && this.storeOut !== '' && min_storeIn > min_storeOut) {
            this.$message.error({ message: this.$t('COMMON.MSG_STORE_INOUT_VALIDITY'), showClose: true });//入店＜退店で入力してください。
            return;
          }
          // 入退店時刻の差チェック
          if (this.storeOut !== null && this.storeOut !== '' && (min_storeOut - min_storeIn) > 24 * 60) {
            this.$message.error({ message: this.$t('COMMON.MSG_STORE_INOUT_SA_VALIDITY'), showClose: true });//入店時刻から退店時刻が24時間以内になるよう時刻を入力してください。
            return;
          }
          //if (this.workType === '3') {
            //出発コール、入店両方存在、出発コール＞入店の場合
            //if (this.departureCall !== null && this.departureCall !== '' && this.storeIn !== null && this.storeIn !== '' && min_departureCall > min_storeIn) {
            //  this.$message.error({ message: this.$t('COMMON.MSG_DEPARTURE_CALL_IN_VALIDITY'), showClose: true });//出発コール＜入店で入力してください。
            //  return;
            //}
            //退店コール、退店両方存在、退店＞退店コールの場合
            //if (this.returnCall !== null && this.returnCall !== '' && this.storeOut !== null && this.storeOut !== '' && min_storeOut > min_returnCall) {
            //  this.$message.error({ message: this.$t('COMMON.MSG_RETURN_CALL_OUT_VALIDITY'), showClose: true });//退店＜退店コールで入力してください。
           //   return;
            //}
          //}
        }
      
        //実働時間、内深夜実働時間計算
        this.workTime = this.calculateWorkTime()
        this.latenightWorkTime = this.calculateLatenightWorkTime()
        //勤怠項目チェック
        if(this.timeFlag=='1'){
          // 休憩時間の合理性チェック(内深夜休憩＞全休憩時間)：
          if (min_inLateBreak > min_allRestTime) {
            this.$message.error({ message: this.$t('COMMON.MSG_RESTTIME_VALIDITY'), showClose: true });//休憩時間を正しく入力してください。
            return;
          }
          // 休憩時間の合理性チェック(入店・退店両方存在、全休憩時間＞（退店-入店)：
          if (this.storeOut !== null && this.storeOut !== '' && min_allRestTime > (min_storeOut - min_storeIn)) {
            this.$message.error({ message: this.$t('COMMON.MSG_RESTTIME_VALIDITY'), showClose: true });//休憩時間を正しく入力してください。)
            return;
          }

          //実働時間(分)
          if (this.workTime === null || this.workTime === '') {
            var min_workTime = 0;
          } else {
            var min_workTime = Number(this.workTime.substring(0, 2)) * 60 + Number(this.workTime.substring(3, 5));
          }
          var check_msg = [];
          //勤怠チェック(実働8時間超で休憩が60分未満)
          if (min_workTime > 8 * 60 && min_allRestTime < 60) {
            check_msg.push('・' + this.$t('COMMON.MSG_KINTAI_CHECK2'))//休憩時間を再確認してください。（実働8H超で休憩1H未満）。
          }
          //勤怠チェック(実働6時間超で休憩が45分未満)
          if (min_workTime > 6 * 60 && min_allRestTime < 45) {
            check_msg.push('・' + this.$t('COMMON.MSG_KINTAI_CHECK3'));//休憩時間を再確認してください。（実働6H超で休憩0.75H未満）
          }
          //勤怠チェック(実動時間12時間超)
          if (min_workTime > 12 * 60) {
            check_msg.push('・' + this.$t('COMMON.MSG_KINTAI_CHECK4'))//残業時間を再確認してください。
          }
          //勤怠チェック(実働0)
          if (min_workTime === 0) {
            check_msg.push('・' + this.$t('COMMON.MSG_KINTAI_CHECK5'))//勤怠を確認してください。
          }
        }
        //勤怠チェックpop処理
        if (this.timeFlag=='1' && check_msg.length > 0 && this.storeOut) {
          const newDatas = []
          const newDatas1 = []
          const h = this.$createElement
          newDatas.push(h('h3', { style: 'text-align:left' }, this.$t('COMMON.MSG_KINTAI_CHECK_TITTLE')))
          newDatas1.push(h('h3', { style: 'text-align:left' }, this.$t('COMMON.MSG_KINTAI_CHECK_TITTLE')))
          for (const i in check_msg) {
            newDatas.push(h('p', { style: 'text-align:left' }, check_msg[i]))
          }
          this.$confirm(
            h('div', null, newDatas), '', {
            confirmButtonText: this.$t('COMMON.BTN_REGIST'),//登録
            cancelButtonText: this.$t('COMMON.BTN_CHANGE'),//修正
            cancelButtonClass: "btn-custom-cancel_k0002",
            confirmButtonClass: "btn-custom-confirm_k0002",
            center: true,
            showClose: false,
            type: 'warning'
          }).then(() => {
            // 登録の場合、保存処理
            // //图片控件取得（用于判断画面上是否有图片）
            // let image_control = document.querySelector(
            //   ".el-upload-list__item-thumbnail"
            // );
            // //タイムシート添付チェック
            // if (this.workType === '3' && image_control === null && this.storeOut !== '') {
            //   this.$message.error({ message: this.$t('COMMON.MSG_MESSAGETIMESHEET_PHOTO_CHECK'), showClose: true });//タイムシート写真を添付してください。
            // } else {
            //   this.allSave()
            // }
            this.allSave()
          }).catch(() => {
            // 修正の場合、取消 
          });
        } else {
          // let image_control = document.querySelector(
          //   ".el-upload-list__item-thumbnail"
          // );
          //タイムシート添付チェックz
          // if (this.workType === '3' && image_control === null && this.storeOut !== '') {
          //   this.$message.error({ message: this.$t('COMMON.MSG_MESSAGETIMESHEET_PHOTO_CHECK'), showClose: true });//タイムシート写真を添付してください。
          // } else {
          //   this.allSave()
          // }
          this.allSave()
        }
      } else {
        //無処理
      }
    },
    //保存处理 (コールフラグは3:明細専用)
    allSave() {
      if (this.timeFlag=='1' && (this.storeOut === null || this.storeOut === "")) {
        var save_msg = this.$t('MODULE.K0002_MSG_NO_STOREOUT')
      } else {
        var save_msg = this.$t('COMMON.MSG_SAVE')
      }
      this.$confirm(save_msg, {//保存しても、よろしいでしょか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),//はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),//キャンセル
        center: true
      }).then(() => {
        this.set_loading()
        this.photoFormData = new FormData()
        var that = this
        //若没进行过图片操作，不保存图片，只保存数据
        if (!this.has_UpdateLoadedDel) {
          this.save_do()
        } else {
          //有图片操作且图片上传list有的场合，保存图片
          if (this.updateLoad_timeSheetImageList.length !== 0 && Object.keys(this.updateLoad_timeSheetImageList[0]).length !== 0) {
            this.photoFormData.append('files', this.updateLoad_timeSheetImageList[0].files, this.updateLoad_timeSheetImageList[0].photoPath)
            amsApi.k_0002_saveImage(this.photoFormData).then(res => {
              //保存图片成功，保存数据
              if (res.code == 205) {
                that.save_do()
              } else if (res.code == 311) {
                 this.close_loading()
                //图片上传失败
                that.$message.error({ message: that.$t('COMMON.CURD_ERROR'), showClose: true }) // 更新失敗
              }
            })
          } else {
            //有图片操作且图片上传list没有的场合，不保存图片，只保存数据
            this.save_do()
          }
        }
      }).catch(() => {
        // 取消
      })
    },
    // 数据保存処理(コールフラグは3:明細専用)
    save_do() {
      var update_params_list = []
      var update_params = {}
      update_params.crewCd = this.crewCd
      update_params.userCd = this.userInfo.userCd
      update_params.jobDate = this.job_date
      update_params.storePositionCd = this.storePositionCd
      // update_params.storePositionCdNew = this.storePositionCd
      update_params.teamCd = this.teamCd
      update_params.storeIn = this.storeIn
      update_params.storeOut = (this.storeOut === null || this.storeOut === '') ? '' : this.storeOut
      if(this.timeFlag === '1'){
        if(this.allRestTime === null || this.allRestTime === ''){
          update_params.allRestTime ='00:00'
        }else{
          update_params.allRestTime=this.allRestTime
        }
        if(this.inLateBreak === null || this.inLateBreak === ''){
          update_params.inLateBreak ='00:00'
        }else{
          update_params.inLateBreak=this.inLateBreak
        }
      }else{
        update_params.allRestTime=''
        update_params.inLateBreak=''
      }
      update_params.workTime = this.timeFlag ==='0'?'':this.workTime
      update_params.latenightWorkTime = this.timeFlag ==='0'?'':this.latenightWorkTime
      update_params.sign = ''
      update_params.jobState = this.jobState
      update_params.selfFlag = 1
      update_params.updateDate = this.updateDate
      update_params.trminal = 'staff'
      update_params.gamenId = 'SK_0002'
      update_params.div = '2'
      update_params.photoItem = []
      update_params.departureCallMemo = this.timeFlag ==='0'?'':this.departureCallMemo
      update_params.returnCallMemo = this.timeFlag ==='0'?'':this.returnCallMemo
      update_params.delPhotoUrl = ''
      update_params.timeFlag = this.timeFlag
      update_params.attendanceDiv = this.attendanceDiv
      update_params.storePositionDisplayCd= this.storePositionDisplayCd
      if (this.has_UpdateLoadedDel) {
        update_params.timesheetCheck = 0
      }
      //作業区分は「3」（派遣・その他請負）かつ選択した出勤区分の時刻フラグは0の場合 出発コール''  退店コール''
      if (this.workType === '3' && this.timeFlag ==='0') {
        update_params.departureCall = ''  
        update_params.returnCall = '' 
      }
      //状態设定
      if (this.workType === '1' || this.workType === '2') {
        update_params.personalJobState = '0'
      } else if (this.workType === '3' && this.jobState === '0') {
        update_params.personalJobState = '0'
      } else if (this.workType === '3' && this.jobState !== '0' && this.timeFlag ==='0') {
        update_params.personalJobState = '0'
      } else if (this.workType === '3' && this.jobState !== '0' && this.timeFlag !=='0') {
        update_params.personalJobState = this.getPersonalJobState()  
      } else {
        //無処理
      }
      //有图片操作且图片上传list没有的场合，图片信息设为空 删除图片
      if (this.has_UpdateLoadedDel && (this.updateLoad_timeSheetImageList.length === 0 || (this.updateLoad_timeSheetImageList.length === 1) && Object.keys(this.updateLoad_timeSheetImageList[0]).length === 0)) {
        update_params.photoItem.push({
          photoId: '',
          photoPath: '',
          type: '0',
        })
        update_params.delPhotoUrl = this.delPhotoUrl
        //进图片上传list不为空的场合，保存图片信息
      } else if (this.updateLoad_timeSheetImageList.length !== 0 && Object.keys(this.updateLoad_timeSheetImageList[0]).length !== 0) {
        update_params.photoItem.push({
          photoId: this.updateLoad_timeSheetImageList[0].photoId,
          photoPath: this.updateLoad_timeSheetImageList[0].photoPath,
          type: this.updateLoad_timeSheetImageList[0].type,
        })
        update_params.delPhotoUrl = this.delPhotoUrl
      } else {
        //无处理
      }
      update_params_list.push(update_params)
      // 保存接口调用
      amsApi.k_0002_update(update_params_list).then(res => {
         this.close_loading()
        this.res_code_back(res)
      })
    },

    //时间比较
    compareDate(date) {
      var date1 = new Date(date);
      var date2 = new Date();
      date1.setDate(date1.getDate() + 1);
      date2.setDate(date2.getDate());
      var month1 = date1.getMonth() + 1;
      var month2 = date2.getMonth() + 1;
      var day1 = date1.getDate();
      var day2 = date2.getDate();
      var d1 = date1.getFullYear() + '/' + this.getFormatDate(month1) + '/' + this.getFormatDate(day1);
      var d2 = date2.getFullYear() + '/' + this.getFormatDate(month2) + '/' + this.getFormatDate(day2);
      var time1 = parseInt(Date.parse(new Date(d1)) / 1000 / 3600 / 24);
      var time2 = parseInt(Date.parse(new Date(d2)) / 1000 / 3600 / 24);
      var nDays = time2 <= time1;
      return nDays;
    },
    // date->string(0:yyyymmdd  1:yyyy/mm/dd ) 変化
    dateToString (dateTime, changeType) {
      var strTime = ''
      if (dateTime == null) { return null }
      var year = dateTime.getFullYear()
      var month = (dateTime.getMonth() + 1).toString()
      var day = (dateTime.getDate()).toString()
      if (month.length === 1) { month = '0' + month }
      if (day.length === 1) { day = '0' + day }
      if (changeType === '0') {
        strTime = year + month + day
      } else if (changeType === '1') {
        strTime = year + '/' + month + '/' + day
      } else {
        strTime = year + month + day
      }
      return strTime
    },
    //时间格式化
    getFormatDate(arg) {
      if (arg == undefined || arg == '') {
        return '';
      }
      var re = arg + '';
      if (re.length < 2) {
        re = '0' + re;
      }
      return re;
    },
    //0005182: スタッフ側：勤怠詳細画面経費項目制御変更

    //计算実動時間  退店-入店-全休憩時間。
    calculateWorkTime() {
      //var cal_result = 0;
       var ret ='';
      if (this.storeIn === null || this.storeIn === '' || this.storeOut === null || this.storeOut === '') {
         ret ='';
      } else {
        var cal_storeIn = (this.storeIn === null || this.storeIn === '') ? "0" : Number(this.storeIn.substring(0, 2)) * 60 + Number(this.storeIn.substring(3, 5))
        var cal_storeOut = (this.storeOut === null || this.storeOut === '') ? "0" : Number(this.storeOut.substring(0, 2)) * 60 + Number(this.storeOut.substring(3, 5))
        var cal_allRestTime = (this.allRestTime === null || this.allRestTime === '') ? "0" : Number(this.allRestTime.substring(0, 2)) * 60 + Number(this.allRestTime.substring(3, 5))
        var cal_result = (cal_storeOut - cal_storeIn - cal_allRestTime) < 0 ? 0 : (cal_storeOut - cal_storeIn - cal_allRestTime)
        ret = this.minuteTOtime(cal_result)
      }
      return ret
    },
    //计算内深夜実動時間  深夜时间-内深夜休憩時間。
    calculateLatenightWorkTime() {
      // var cal_result = 0;
      var ret ='';
      if (this.storeIn === null || this.storeIn === '' || this.storeOut === null || this.storeOut === '') {
        ret ='';
      } else {
        var cal_storeIn = (this.storeIn === null || this.storeIn === '') ? "0" : Number(this.storeIn.substring(0, 2)) * 60 + Number(this.storeIn.substring(3, 5))
        var cal_storeOut = (this.storeIn === null || this.storeOut === '') ? "0" : Number(this.storeOut.substring(0, 2)) * 60 + Number(this.storeOut.substring(3, 5))
        var cal_inLateBreak = (this.inLateBreak === null || this.inLateBreak === '') ? "0" : Number(this.inLateBreak.substring(0, 2)) * 60 + Number(this.inLateBreak.substring(3, 5))
        var inlateBlock = this.getInLateBlock(cal_storeIn, cal_storeOut)//深夜时间取得
        var cal_result = (inlateBlock - cal_inLateBreak) < 0 ? 0 : (inlateBlock - cal_inLateBreak)
        ret = this.minuteTOtime(cal_result)
      }
     
      return ret
    },

    //分钟 转 【时：分】
    minuteTOtime(val) {
      var ret = ""
      if (val === '' || val === '0') {
        ret = '00:00'
      } else {
        ret = ((Math.floor(val / 60)).toString().length < 2 ? "0" + (Math.floor(val / 60)).toString() : (Math.floor(val / 60)).toString()) + ":" + ((val % 60).toString().length < 2 ? "0" + (val % 60).toString() : (val % 60).toString());
      }
      return ret
    },
    // date->string(HH:MM) 変化
    dateToStringHHMM(dateTime, addHour) {
      var strTime = ''
      if (dateTime == null) { return '' }
      var hours = dateTime.getHours() + addHour
      var minutes = dateTime.getMinutes()
      if (hours < 10) { hours = '0' + hours }
      if (minutes < 10) { minutes = '0' + minutes }
      strTime = hours + ':' + minutes
      return strTime
    },
    //個人作業状態  戻り値：0:計画、1:出発済、2:入店済、3:退店済、4:作業完了
    //個人作業状態の判断について、下記の条件を順番にチェックする																													
    //退店コールがある場合、'4'にする。それ以外は続き処理になる																											
    //	退店がある場合、'3'にする。それ以外は続き処理になる																										
    //		入店がある場合、'2'にする。それ以外は続き処理になる																									
    //			出発コールがある場合、'1'にする。それ以外は'0'にする	
    getPersonalJobState() {
      if (this.returnCall !== null && this.returnCall !== '') {
        return '4'
      } else if (this.storeOut !== null && this.storeOut !== '') {
        return '3'
      } else if (this.storeIn !== null && this.storeIn !== '') {
        return '2'
      } else if (this.departureCall !== null && this.departureCall !== '') {
        return '1'
      } else {
        return '0'
      }
    },
    //出勤区分リスト取得
    searchAttendanceList(){
      var div = '25';
      amsApi.conditionApi('all', div).then(res => {
        this.attendanceList = res.items.attenDiv
        for (var item of this.attendanceList) {
          if(this.attendanceDiv==item.attendanceDiv){
            this.attenAbbr=item.attenAbbr
          }
          if (item.attenAbbr == '') {
            item.attenAbbr = ' '
          }
        }
      });
    },
    //出勤区分选择
    attendanceDivSelect(val) {
      if (val === '') {
        this.timeFlag = ''
        this.attendanceDiv= ''
      } else if (val !== '') {
        var attendanceObj = this.attendanceList.find((item) => {
          return item.attendanceDiv === val
        })
        this.timeFlag = attendanceObj.timeFlag
        this.attendanceDiv = attendanceObj.attendanceDiv
        this.attenAbbr=attendanceObj.attenAbbr
        if(this.timeFlag ==="0"){
          this.storeIn=''
          this.storeOut=''
          this.allRestTime=''
          this.inLateBreak=''
          this.workTime=''
          this.latenightWorkTime=''
          if(this.workType=='3'){
            this.departureCallMemo=''
            this.returnCallMemo=''
          }
        }

      }
    },
  },    

  // 初期化自动调用
  created() {
    // 昨日(date)
    var yesterday = new Date()
    yesterday = yesterday.setDate(yesterday.getDate() - 1)
    yesterday = new Date(yesterday)
    // 昨日(str)
    this.strYesterday = this.dateToString(yesterday, '1')

    this.obj = JSON.parse(localStorage.getItem('obj'))
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.storePositionCd = this.obj.storePositionCd
    this.crewCd = this.obj.crewCd
    this.jobState = this.obj.jobStateCd
    // 勤怠承認FLAG
    this.approvalFlag = this.obj.approvalFlag
    //add by hexy 20200921 start
    this.transmitFlag = this.obj.transmitFlag
    //add by hexy 20200921 end

    this.esStoreIn = this.obj.esStoreIn
    this.esStoreOut = this.obj.esStoreOut
    this.workType = this.obj.workType
    this.goalFlg = this.obj.goalFlg
    this.fieldName = this.obj.fieldName
    // コールフラグは1:出発コール以外の場合 初期化函数调用
    if (this.goalFlg !== '1') {
      this.query()
    } else {
      this.company_name = this.obj.companyName
      this.job_date = this.obj.jobDate
    }
    if (this.jobState == this.WORKING) {
      this.jobState_working = true
    } else {
      this.jobState_working = false
    }
    
  },
  mounted() {
    //点击删除按钮之外的地方退出长按模式
    let that = this;
    document.addEventListener('click', function (e) {
      if (e.target.className != 'el-upload-list__item-actions'
        && e.target.className != 'el-icon-refresh-left'
        && e.target.className != 'el-icon-refresh-right'
        && e.target.className != 'el-icon-c-scale-to-original'
        && e.target.className != 'el-icon-zoom-in'
        && e.target.className != 'el-icon-zoom-out'
        && e.target.className != 'el-image-viewer__actions__inner'
        && e.target.className != 'el-icon-full-screen'
        && e.target.className != 'el-icon-circle-close'
        && e.target.className != 'el-button el-button--default el-button--small'
      ) {
        that.imageDialogVisible = false
      }
    })

  }
}
</script>
<style scope>
.btn-custom-cancel_k0002 {
  background-color: #409eff !important;
  color: #ffffff !important;
}
.btn-custom-confirm_k0002 {
  border: 1px solid #dcdfe6 !important;
  background-color: #ffffff !important;
  color: #000000 !important;
}
/*panel下全部区域*/
.all_area_k0002 {
  margin-left: 0px;
}
/*检索条件整体样式*/
.span_search_condition_k0002 {
  padding-left: 20px;
  font-size: 10pt;
}
/*下半部入力框内部长度 第一行*/
.textRight .el-input__inner {
  text-align: right;
}
.textLeft .el-input__inner {
  text-align: left;
}
/*按钮样式*/
.Location_k0002 {
  position: relative;
  top: 50%;
  left: 50%;
  height: 30%;
  text-align: center;
  padding: 20px;
}
/*上半部行样式*/
.el-row_k0002 {
  margin-bottom: 10px;
}
/*上半部列样式*/
.el-col_k0002 {
  border-radius: 4px;
  width: 100%;
}

/*下半部span样式*/
.input_span_k0002 {
  padding: 0px 0px 0px 21px;
  float: left;
  height: 30px;
  min-height: 30px;
  color: #ffffff;
  width: 40%;
}
.input_span2_k0002 {
  float: left;
  height: 30px;
  min-height: 30px;
  color: #ffffff;
  width: 20%;
}
/*下半部span用div样式*/
.div_span_k0002 {
  background-image: linear-gradient(#3cc6fa, #1197ca);
  width: 100%;
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  margin: 0px;
  border: 0;
  padding: 0;
  font-size: 10pt;
}
/*下半部input用div样式*/
.div_input_k0002 {
  width: 100%;
  height: 55px;
  line-height: 50px;
  background: #d2eef8;
  float: left;
  margin: 0px;
  border: 0;
  padding: 0;
}
/*textarea用div框样式*/
.div_textarea_k0002 {
  width: 100%;
  height: 70px;
  line-height: 50px;
  background: #d2eef8;
  float: left;
  margin: 0px;
  border: 0;
  padding: 0;
}
.input_textarea_k0002 {
  width: 85%;
  min-width: 40%;
  padding: 8px 0px 6px 20px;
  float: left;
  min-height: 30px;
  color: #000000;
  vertical-align: top;
}

.all_area_k0002 .el-textarea__inner {
  resize: none;
}
/*image用div样式*/
.div_image {
  background: #d2eef8;
}
/*下半部input样式 第一行*/
.input_input1_k0002 {
  width: 40%;
  min-width: 40%;
  padding: 3px 0px 0px 20px;
  float: left;
  min-height: 30px;
  color: #000000;
  vertical-align: top;
}
.input_input2_k0002 {
  width: 20%;
  min-width: 20%;
  float: left;
  min-height: 30px;
  color: #000000;
  vertical-align: top;
}
.input_input3_k0002 {
  width: 20%;
  min-width: 20%;
  float: left;
  min-height: 30px;
  color: #918d8d;
  vertical-align: top;
}
/*下半部整体div样式*/
.el-detail_k0002 {
  width: 100%;
  height: 100%;
}
.el-input__inner {
  line-height: 20px;
}
/* 分割线上下外边距 */
.c0004-divider .el-divider--horizontal {
  margin-top: 8px;
  margin-bottom: 8px;
}
/*只读框字体颜色*/
.readonly_input .el-input .el-input__inner {
  border-color: rgb(228, 231, 237);
  color: #818181;
}
/*只读框字体颜色1*/
.readonly_input1 .el-input .el-input__inner {
  border-color: rgb(228, 231, 237);
  background-color: rgb(239, 240, 243);
  color: #acacaa;
}
.readonly_textarea .el-textarea .el-textarea__inner {
  border-color: rgb(228, 231, 237);
  background-color: rgb(239, 240, 243);
  color: #acacaa;
}
.readonly_input1.el-input.is-disabled .el-input__inner {
  border-color: rgb(228, 231, 237);
  background-color: rgb(239, 240, 243);
  -webkit-text-fill-color: #acacaa;
  opacity: 1;
}
.readonly_input1 input:disabled{
  -webkit-text-fill-color: #acacaa;
}
/*safari用 去掉入力框阴影*/
.all_area_k0002 textarea {
  -webkit-appearance: none;
}
/*input输入框*/
.css-input-width_k0002 {
  width: 72%;
}
.search-module_k0002 {
  padding-bottom: 10px;
  margin-bottom: 10px; /*检索模块与表格间距*/
  width: 100%;
  background-image: linear-gradient(#f8f6f6, #dfdfdf);
}
/*面包屑*/
.el-crumb_k0002 {
  background-image: linear-gradient(#5c5d5d, #717171);
  padding-left: 5px;
  padding-top: 4px;
  height: 20px;
}
/*导航*/
.home-content-menu_k0002 {
  padding-left: 0;
  height: 40px;
  background-color: #23b2e8;
}

.all_area_k0002 .avatar-uploader .el-upload {
  margin-top: 8px;
  height: 38px;
  width: 100%;
  border: 1px solid #8a8989;
  border-radius: 6px;
}
.all_area_k0002 .avatar-uploader .el-upload:hover {
  border-color: #409eff;
  width: 100%;
  height: 38px;
}
.all_area_k0002 .photo {
  float: left;
  width: 20%;
  height: 40px;
  margin-left: 20px;
}

.all_area_k0002 .photo_button {
  float: left;
  width: 20%;
  margin-left: 5px;
}
/* 去除上传图片动画 */
.all_area_k0002 .el-upload-list__item {
  transition: none !important;
}
.all_area_k0002 .el-upload-list__item-actions {
  padding-left: 15px;
  padding-top: 14px;
  height: 60px;
}
/* 假图片边框 */
.all_area_k0002 .image_border {
  float: left;
  width: 115px;
  height: 55px;
  margin-left: 33px;
  margin-top: 7px;
  position: relative;
  border: 1px solid #409eff;
  border-radius: 5px;
}
/* timesheet整体样式 */
.all_area_k0002 .photo_div {
  height: 71px;
  background-color: #d2eef8;
}
/* timesheet右半部分 */
.all_area_k0002 .photo_div .el-upload--picture-card {
  width: 120px;
  height: 60px;
  margin-top: 7px;
  margin-left: 40px;
  background-color: #d2eef8;
  border: 1px solid #409eff;
  line-height: 0;
}
/* timesheet左半部分 */
.all_area_k0002 .photo_div .el-upload-list--picture-card .el-upload-list__item {
  width: 120px;
  height: 60px;
  margin-top: 7px;
  margin-left: 30px;
  margin-right: 0px;
}
/* timesheet中间照相机ICON式样 */
.all_area_k0002 .photo_div .el-upload--picture-card i {
  margin-top: 16px;
  color: #409eff;
}
/*预览图右上角叉*/
/* .all_area_k0002 .el-icon-circle-close:before {
  color: #fd270a;
} */
.image_view_red .el-icon-circle-close:before {
  color: #fd270a;
}
.image_view_hidden .el-icon-circle-close:before {
  display: none;
}
</style>





// WEBPACK FOOTER //
// src/module/page/k_0002.vue